export default "__VITE_ASSET__BA1d3OCt__"